<template>
  <div class="container">
    <img src="../../assets/img/404.png" style="width: 400px"/>
    <span>抱歉，我们找不到您要访问的页面</span>
    <el-button :type="`primary`" @click="handleBack" style="margin-top: 20px;">点击返回</el-button>
  </div>

</template>

<script>
export default {
  name: "404",
  methods: {
    handleBack() {
      this.$router.replace('/index')
    }
  }
}

</script>

<style scoped lang="scss">
.container {
  width: 100%;
  padding-top: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #999999;
  font-size: 18px;
}
</style>
